import mainActions from 'actions/mainActions/mainActions';
import { getAuthTokens } from 'utils/tools/tools';
import config from 'config/config';


export const checkAuth = () => (dispatch) => {
  const authCookie = getAuthTokens();

  dispatch(mainActions.updateUserIsLoggedIn(Boolean(authCookie)));
  if (authCookie) {
    const {
      access_token: accessToken,
      refresh_token: refreshToken,
    } = authCookie;
    accessToken && dispatch(mainActions.updateAuthAccessToken(accessToken));
    refreshToken && dispatch(mainActions.updateAuthRefreshToken(refreshToken));
  }
};

export const refreshAccessToken = (retryAction = false, _fetch = fetch, _config = config) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const mainStore = getState().mainStore;
    const isUserLoggedIn = mainStore.get('isUserLoggedIn');
    const refreshToken = mainStore.get('authRefreshToken');
    const iamRefreshUrl = `${_config.IAM_API.BASE_URL}/account/refresh-access-token`;

    if (!isUserLoggedIn) {
      return reject(new Error('User not logged in'));
    }

    const requestOptions = {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        RefreshToken: refreshToken,
        GrantType: 'refresh_token',
        ClientId: 'jg.web',
      }),
    };

    return _fetch(iamRefreshUrl, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          const {
            access_token: accessToken,
            refresh_token,
          } = data.Result;
          dispatch(mainActions.updateAuthAccessToken(accessToken));
          dispatch(mainActions.updateAuthRefreshToken(refresh_token));
          if (retryAction) {
            if (retryAction.CALL_API) {
              retryAction.CALL_API.requestOptions.headers.Authorization = `Bearer ${accessToken}`;
            }
            dispatch(retryAction);
          }
          return resolve({
            accessToken,
            refresh_token,
          });
        })
        .catch((error) => {
          reject(new Error(error));
        });
  });

export default checkAuth;



// WEBPACK FOOTER //
// ./actions/authActions/authActions.js